import React from "react";
import Download from "../assets/download.svg";
import { OutboundLink } from "gatsby-plugin-google-analytics";
import "twin.macro";

const DownloadButton = ({ url }) => (
  <OutboundLink
    href={url}
    eventCategory="GPX Download"
    tw="bg-brand-500 hover:bg-brand-400 text-xs text-white pr-2 inline-flex items-center font-bold rounded uppercase"
  >
    <Download
      tw="h-8 w-8 inline-block fill-current"
      role="img"
      aria-label="Download"
    />
    Download GPX
  </OutboundLink>
);

export default DownloadButton;
